// extracted by mini-css-extract-plugin
module.exports = {"day__price":"day__price-1jbbE","day":"day-2pr2n","day_best":"day_best-22WmQ","selected":"selected-ivMav"};